import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useIdentity } from '../../Authentication/Authentication.hooks';
import { GET_USER_WITH_WALLET, CURRENT_USER } from '../../App.gql';
import WalletCardView from './WalletCard.view';
import WalletDetails from '../WalletDetails/WalletDetails';
import * as Styled from './WalletCard.styled';
import OverlayModal from '../../ContentSystem/components/OverlayModal/OverlayModal';

const WalletCard = ({ className }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [walletDetails, setWalletDetails] = useState(null);
  const { user } = useIdentity();
  const { data: currentUserData } = useQuery(CURRENT_USER);

  const { data: userWithWalletData } = useQuery(GET_USER_WITH_WALLET, {
    variables: {
      email: user?.email,
      customerAccessToken: currentUserData?.customerAccessToken
    },
    skip: !user?.email || !currentUserData?.customerAccessToken
  });

  const walletData = userWithWalletData?.user?.wallet;

  if (!walletData) {
    return null;
  }

  const handleSeeDetailsClick = (details) => {
    setWalletDetails(details);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setWalletDetails(null);
  };

  return (
    <>
      <WalletCardView
        className={className}
        code={walletData.code}
        balance={walletData.balance}
        currency={walletData.currency || 'USD'}
        expirationDate={walletData.expirationDate}
        onSeeDetailsClick={handleSeeDetailsClick}
      />
      {isModalOpen && walletDetails && (
        <OverlayModal
          isOpen={isModalOpen}
          onRequestClose={handleModalClose}
          size="regular"
          headerAlignment="left"
          smallLayoutWithSidePadding
          headerVariant="utility"
          smallLayoutTopMargin={24}
        >
          <Styled.ModalContent>
            <Styled.ModalTitle>Store Credit</Styled.ModalTitle>
            {walletData?.activeCredits && (
              <WalletDetails
                issuances={walletData?.activeCredits.map(
                  ({ note, amount, expirationDate }) => ({
                    label: note,
                    amount,
                    expiresOn: expirationDate
                  })
                )}
                accountCode={walletDetails.code}
                currency={walletDetails.currency || 'USD'}
                expiringSoonDays={walletDetails.expiringSoonDays}
              />
            )}
          </Styled.ModalContent>
        </OverlayModal>
      )}
    </>
  );
};

WalletCard.propTypes = {
  className: PropTypes.string
};

WalletCard.defaultProps = {
  className: undefined
};

export default WalletCard;
